import { useTheme } from '@mui/material';
import { useDrawer } from 'common/hooks';
import { useState } from 'react';
import {
  Chat,
  ChatHistory,
  ChatInterface,
} from './components/matching-engine-chat-interface.component';
import { useGetChat } from './hooks/useChatHooks';
import { DrawerIdEnum } from 'features/org-root/enums/drawer-id.enum';
import { Box, IconButton, Stack, Typography } from 'common/components/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AddIcon from '@mui/icons-material/Add';
import HistoryIcon from '@mui/icons-material/History';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DEFAULT_APP_BAR_HEIGHT } from 'common/components/header/ApplicationBar';
import CloseIcon from '@mui/icons-material/Close';

const DRAWER_HEADER_HEIGHT = 44;

export const AskConnectXDrawer: React.FC = () => {
  const { palette } = useTheme<any>();
  const { closeDrawer } = useDrawer();

  const [isHistoryView, setIsHistoryView] = useState(false);
  const [initialChat, setInitialChat] = useState<Chat[]>([]);
  const [initialChatId, setInitialChatId] = useState<string | null>(null);
  const [currentChatId, setCurrentChatId] = useState<string | null>(null);

  const { mutateAsync: getChat } = useGetChat();

  const closeCurrentDrawer = () => {
    closeDrawer(DrawerIdEnum.ASK_CONNECTX_DRAWER);
  };

  const handleChatSelection = async (id: string) => {
    const { data } = (await getChat({
      chatId: id,
    })) as {
      data: {
        chat: Chat[];
      };
    };

    setCurrentChatId(id);
    setInitialChat(data.chat);
    setInitialChatId(id);
    setIsHistoryView(false);
  };

  const addNewChat = () => {
    setInitialChat([]);
    setCurrentChatId(null);
    setInitialChatId(null);
    setIsHistoryView(false);
  };

  return (
    <Box
      id="ask-connectx-drawer"
      sx={{
        height: `calc(100vh - ${DEFAULT_APP_BAR_HEIGHT})`,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          flexShrink: 0,
          height: DRAWER_HEADER_HEIGHT,
          px: 1,
          borderBottom: `1px solid ${palette.Divider}`,
          backgroundColor: palette.Background,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <AutoAwesomeIcon
            sx={{
              color: palette.Icons.Primary.IconFill,
              fontSize: 16,
            }}
          />

          <Typography variant="body2" fontWeight={500}>
            Ask ConnectX
          </Typography>
        </Stack>

        <Stack direction="row" spacing={0.25}>
          <IconButton size="small" onClick={addNewChat}>
            <AddIcon sx={{ fontSize: 18 }} />
          </IconButton>

          <IconButton size="small" onClick={() => setIsHistoryView((prev) => !prev)}>
            {isHistoryView ? (
              <ArrowBackIcon sx={{ fontSize: 18 }} />
            ) : (
              <HistoryIcon sx={{ fontSize: 18 }} />
            )}
          </IconButton>

          <IconButton size="small" onClick={closeCurrentDrawer}>
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Stack>
      </Stack>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        {isHistoryView ? (
          <Box
            sx={{
              height: '100%',
              px: 1,
              overflow: 'hidden',
            }}
          >
            <ChatHistory selectedChatId={currentChatId} onSelect={handleChatSelection} />
          </Box>
        ) : (
          <ChatInterface initialChat={initialChat} initialChatId={initialChatId} />
        )}
      </Box>
    </Box>
  );
};
